import React, { useState } from "react";
import clsx from "clsx/lite";

const Tooltip = ({ children, message, enabled, containerClass, className }) => {
	const [visible, setVisible] = useState(false);

	if (!enabled || !message) return children;

	const show = () => setVisible(true);
	const hide = () => setVisible(false);
	const toggle = () => setVisible(v => !v);

	return (
		<div
			className={clsx("relative flex items-center", containerClass)}
			onMouseEnter={show}
			onMouseLeave={hide}
			onTouchStart={toggle}
		>
			{children}
			{visible && (
				<div
					className={clsx(
						"absolute bottom-full mb-2 z-50 left-1/2 -translate-x-1/2",
						"bg-black text-white text-xs text-center rounded px-3 py-2 shadow-md",
						"whitespace-normal break-words w-[150px] md:w-max transition-opacity duration-200 pointer-events-none",
						className
					)}
					style={{
						insetInline: "auto",
						maxWidth: "min(220px, 90vw)",
					}}
				>
					{message}
				</div>
			)}
		</div>
	);
};

export default Tooltip;
